var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OrderManagement"},[(_vm.nowPage == '修改完工回報')?[_c('modOrderRecord')]:(_vm.nowPage == '新增完工回報')?[_c('addOrderRecord')]:(_vm.nowPage == '人工處理紀錄')?[_c('manualRecord')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f965fd72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/OrderManagement.vue
// module id = null
// module chunks = 